import { Component } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
  selector: 'app-ag-grid-index-selection-cell-renderer',
  templateUrl: './ag-grid-index-selection-cell-renderer.component.html',
  styleUrl: './ag-grid-index-selection-cell-renderer.component.scss'
})
export class AgGridIndexSelectionCellRendererComponent implements ICellRendererAngularComp {

  public params: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onCheckboxChange(event: MatCheckboxChange) {
    this.params.node.setSelected(event.checked);
  }

}
